import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsEBikeRideNormalMedium = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M25 18.22a6.485 6.485 0 00-2.16.36l-2.48-4.75h3.15a.614.614 0 01.52.25.706.706 0 01.06.76.686.686 0 01-.56.33H23v1.66h.53a2.343 2.343 0 001.97-1.14 2.306 2.306 0 00-.1-2.53 2.252 2.252 0 00-1.89-.99h-5.87l1.57 3h-8.534l-1.244-2.34h1.988l-.88-1.66H5.08l.88 1.66h1.6l1.25 2.345H2.963a1.1 1.1 0 01-1.049-.679 1.136 1.136 0 01-.09-.451V6A1.176 1.176 0 013 4.826h12.26a3.851 3.851 0 003.74 3h2.83v-1H24V5.175h-2.17v-2.35H24v-1.65h-2.17V.17H19a3.851 3.851 0 00-3.74 3H3A2.829 2.829 0 00.175 6v8.049a2.808 2.808 0 00.859 2.022 2.678 2.678 0 001.85.756H9.6l-.872 1.623a6.823 6.823 0 105.046 7.382h1.676l4.56-9.13 1.35 2.58A6.818 6.818 0 1025 18.22zm-14.42.29l3.012 5.66H7.54zM7 30.221a5.175 5.175 0 11.932-10.265L5.87 23.8l1.05 2.03h5.18A5.169 5.169 0 017 30.221zm7.93-7.051l-3.371-6.34h6.54zM25 30.22a5.17 5.17 0 01-2.87-9.47l2.66 5.09h1.85l-3.02-5.78A5.172 5.172 0 1125 30.22z"
        fill=""
      />
    </svg>
  )
);
SvgSportsEBikeRideNormalMedium.defaultProps = {
  color: 'currentColor',
  size: 32,
  title: undefined,
  titleId: undefined
};
SvgSportsEBikeRideNormalMedium.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsEBikeRideNormalMedium;
